<div class="mock-page">
  <div class="mock-message">
    <p class="mock-text">Admin page.</p>
  </div>
</div>
